const o=({children:e})=>e;export{o as Else};
